import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash-small",
  "use": "trash-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"trash-small\">\n  <path d=\"M6 12.5v-6h1v6H6zm4-6H9v6h1v-6zm4-1.483h-1V15H3V5.017H2V2h4V1h4v1h4v3.017zm-2 0H4V14h8V5.017zM13 3H3v1.017h10V3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol